"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RequestStatusPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var RequestStatusTypes = (0, _keyMirror.default)({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});

var RequestStatusPropType = _propTypes.default.oneOf(Object.keys(RequestStatusTypes));

exports.RequestStatusPropType = RequestStatusPropType;
var _default = RequestStatusTypes;
exports.default = _default;